import React from 'react';
import './Checkbox.css';
import { IconCheckmark } from '../icons';

export type Props = {
  disabled?: boolean;
  name: string;
  label?: string | JSX.Element;
  inverse?: boolean;
  onChange?: (e: React.FormEvent<HTMLInputElement>) => void;
  checked?: boolean;
  tooltip?: string;
} & React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
>;

const clickCheckbox = (e: React.FormEvent<HTMLDivElement>) => {
  e.currentTarget.getElementsByTagName('input')[0].click();
};

export const Checkbox = ({
  disabled,
  name,
  label,
  inverse,
  onChange,
  checked = false,
  tooltip,
  ...rest
}: Props) => {
  const classNames = () => {
    let classes: string = '';
    if (inverse) {
      classes += ' inverse';
    }
    if (checked) {
      classes += ' green';
    }
    if (disabled) {
      classes += ' disabled';
    }
    return classes;
  };
  return (
    label ? (
      <span className='CheckboxWrapper'>
        <label
          title={tooltip}
          onClick={(e) => {
            e.stopPropagation();
          }}
          className={'Checkbox' + classNames()}
          htmlFor={name + '-checkbox'}
        >
          <IconCheckmark />
          <span className="text">{label}</span>
        </label>
        <input id={name + '-checkbox'} type="checkbox" checked={checked} onChange={onChange} disabled={disabled} {...rest} />
      </span>
    ) : (
      <span className='CheckboxWrapper'>
        <div className={'Checkbox' + classNames()} onClick={clickCheckbox} title={tooltip}>
          <input id={name + '-checkbox'} type="checkbox" checked={checked} onChange={onChange} onClick={(e) => e.stopPropagation()} {...rest} />
          <IconCheckmark />
        </div>
      </span>
    )
  )
};
